import { UserReqDetials } from "./UserReqDetials";
import { useForm } from 'react-hook-form';
import React, { useState } from 'react';

import { apiFetch } from '../../../hooks/apiFetch';
import Timer from "../../../utilities/timer";
import { handlePDFClick } from "../../../utilities/handleFunctions/HandlePDFOpen"
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";

export default function Requests({ orderId, serviceName, numberOfForms, language, orderDescription, orderCreated, subServices, orderStatus, offerFile, offerPrice, offerNote, customerFile, orderDataStatus }) {
    const { handleSubmit, setValue } = useForm();
    const [, setErrorMessage] = useState('');
    const { t } = useTranslation();
    // default reply hours
    const addHours = 24;

    async function onSubmit(data) {
        console.log("Form data: ", data, orderId); // Debug: Check form data
        try {
            const response = await apiFetch(`${process.env.REACT_APP_MASAR_API_URL}/orders/${orderId}`, {
                method: "PATCH",
                body: JSON.stringify(data)
            });
            if (response.isSuccess) {
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            } else {
                setErrorMessage(t("errorTryAgain"), response.message);
            }
        } catch (error) {
            console.error("Error during form submission: ", error); // Debug: Check error
            setErrorMessage(t("errorTryAgain"));
        } finally {
        }
    }

    return (
        <tr
        // className={`${orderStatus === "Pending"
        //     && "table-warning"} ${orderStatus === "Completed"
        //     && "table-success"}`}
        >

            <td className="col " > {`${moment(orderCreated).format('YY')}${new Intl.NumberFormat("en-IN", { minimumIntegerDigits: 3 }).format(orderId,)}`}</td>
            <td className="col-2">
                {moment(orderCreated).format('DD-MM-YYYY')}</td>
            <td className="col-5">{serviceName}<br />
                <Link
                    className="text-decoration-underline c-lightBeige "
                    data-bs-toggle="modal"
                    data-bs-target={`#user-order-details-${new Intl.NumberFormat("en-IN", { minimumIntegerDigits: 3 }).format(orderId,)}`}>
                    {t("Details")}</Link></td>
            <td className="col-2 text-center">{orderStatus}
                <button className={`btn-masar-sm ${offerFile && "btn btn-success"} ms-1`}
                    value={offerFile}
                    onClick={offerFile && handlePDFClick}>
                    {offerFile ? t("ShowOffer") : t("InProgress")}</button></td>
            <td className="col-2 text-center">

                {orderDataStatus === "Paid" ? <p className="text-success m-0">{orderStatus}</p>
                    : <>{orderDataStatus === "Approved" ?
                        <p className="c-darkOrange m-0">{t("WaitPayment")}</p>
                        : <>{orderDataStatus === "Rejected" ?
                            <p className="c-darkOrange m-0">{t("underReview")}</p>
                            : <>
                                {offerFile ?
                                    <form className='d-flex flex-column gap-1 text-center align-contents-center'
                                        onSubmit={handleSubmit(onSubmit)}>

                                        <button className="btn-masar-sm btn-dark-orange"
                                            value="Approved"
                                            type="submit"
                                            onClick={(e) => {
                                                setValue("status", e.target.value);
                                            }}
                                        >{t("addToCart")}</button>
                                        <button className="btn-masar-sm btn-med-gray"
                                            value="Rejected"
                                            type="submit"
                                            onClick={(e) => {
                                                setValue("status", e.target.value);
                                            }}
                                        >{t("reject")}</button>
                                    </form> :
                                    <Timer
                                        OrderCreateAt={orderCreated}
                                        H={addHours}
                                        timeAnnounce={t("TimePassed")}
                                    />
                                }
                            </>
                        } </>}
                    </>
                }
                <UserReqDetials
                    orderId={orderId}
                    numberOfForms={numberOfForms}
                    language={language}
                    orderDescription={orderDescription}
                    subServices={subServices}
                    orderStatus={orderStatus}
                    serviceName={serviceName}
                    offerFile={offerFile}
                    offerNote={offerNote}
                    offerPrice={offerPrice}
                    customerFile={customerFile}
                    t={t}
                />
            </td>

        </tr>
    )

};